import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import HeaderMain from '../components/header-main'
import Componenttextimage from '../components/componenttextimage'
import Component3images from '../components/component3images'
import Componentparameters from '../components/componentparameters'
import Componentfaq from '../components/componentfaq'
import FooterMain from '../components/footer-main'
import './robotic-welding.css'

const RoboticWelding = (props) => {
  return (
    <div className="robotic-welding-container">
      <Helmet>
        <title>
          Промышленный робот для сварки | Автоматизация сварки | Arcobo
        </title>
        <meta
          name="description"
          content="Роботизация сварки деталей, сельхозтехники, мебели, труб и металлоконструкций. Снижение брака и рост производительности. Внедрение в Казахстане и Узбекистане."
        />
        <meta
          property="og:title"
          content="Промышленный робот для сварки | Автоматизация сварки | Arcobo"
        />
        <meta
          property="og:description"
          content="Роботизация сварки деталей, сельхозтехники, мебели, труб и металлоконструкций. Снижение брака и рост производительности. Внедрение в Казахстане и Узбекистане."
        />
        <meta
          property="og:image"
          content="https://arcobo.tech/og_image.png"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Промышленный робот для сварки | Автоматизация сварки | Arcobo"
        />
        <meta
          name="twitter:description"
          content="Роботизация сварки деталей, сельхозтехники, мебели, труб и металлоконструкций. Снижение брака и рост производительности. Внедрение в Казахстане и Узбекистане."
        />
        <meta
          name="twitter:image"
          content="https://arcobo.tech/og_image.png"
        />
        <link
          rel="canonical"
          href="https://arcobo.tech/robotic-welding"
        />
        <meta
          property="og:url"
          content="https://arcobo.tech/robotic-welding"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"BreadcrumbList","itemListElement":[{"@type":"ListItem","position":1,"name":"Home","item":"https://arcobo.tech"},{"@type":"ListItem","position":2,"name":"RoboticWelding","item":"https://arcobo.tech/robotic-welding"}]}',
          }}
        />
      </Helmet>
      <HeaderMain rootClassName="header-mainroot-class-name13"></HeaderMain>
      <hr className="robotic-welding-separator1"></hr>
      <Componenttextimage
        image1Src="/0_Main_page/Solution/welding_11.png-1500w.webp"
        image1Alt="Роботизированная сварка"
        rootClassName="componenttextimageroot-class-name1"
        textComponent={
          <Fragment>
            <span className="robotic-welding-text100">
              <span className="H1_small">
                Роботизированные комплексы для автоматизации сварочного
                производства
              </span>
              <br className="robotic-welding-text102"></br>
              <span>
                Arcobo проектирует, производит и внедряет роботизированные
                сварочные комплексы для предприятий машиностроения, металлургии,
                нефтегазовой отрасли и производства металлоконструкций. Решения
                обеспечивают стабильное качество сварки, повышение
                производительности и снижение себестоимости продукции.
              </span>
              <br></br>
              <br className="robotic-welding-text105"></br>
              <span className="robotic-welding-text106 H1_small">
                Преимущества и выгоды:
              </span>
              <br className="robotic-welding-text107"></br>
              <span className="robotic-welding-text108">✔ </span>
              <span className="robotic-welding-text109">
                Производительность до 5 раз
              </span>
              <br></br>
              <span>
                Роботизированная сварка значительно сокращает время изготовления
                изделий за счет высокой скорости перемещения и непрерывной
                работы комплекса.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text114">✔ </span>
              <span className="robotic-welding-text115">
                Стабильное качество каждого шва
              </span>
              <br></br>
              <span>
                Автоматическое выполнение сварки исключает влияние человеческого
                фактора и обеспечивает повторяемость параметров на протяжении
                всего производственного цикла.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text120">✔ </span>
              <span className="robotic-welding-text121">Работа 24/7</span>
              <br></br>
              <span>
                Комплекс способен работать в круглосуточном режиме, повышая
                загрузку оборудования и увеличивая объем выпускаемой продукции.
              </span>
              <br></br>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text126">✔</span>
              <span> </span>
              <span className="robotic-welding-text128">
                Полный цикл внедрения
              </span>
              <br></br>
              <span>
                Arcobo выполняет проектирование, изготовление оснастки,
                программирование, запуск комплекса и обучение персонала.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        componentTitle="Роботизированная сварка"
      ></Componenttextimage>
      <hr className="robotic-welding-separator2"></hr>
      <Component3images
        image1Src="/1_Solution/1_1_1_Welding/201_welding-200h.webp"
        image1Alt="Роботизированная сварка"
        image2Src="/1_Solution/1_1_1_Welding/202_welding-1500w.webp"
        image2Alt="Роботизированная сварка"
        image3Src="/1_Solution/1_1_1_Welding/203_welding-200h.webp"
        image3Alt="Роботизированная сварка"
        rootClassName="component3imagesroot-class-name2"
      ></Component3images>
      <hr className="robotic-welding-separator3"></hr>
      <Componentparameters
        text1={
          <Fragment>
            <span className="robotic-welding-text132">
              <span className="robotic-welding-text133">•</span>
              <span className="robotic-welding-text134">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Промышленный сварочный робот</span>
              <br></br>
              <span className="robotic-welding-text137">•</span>
              <span className="robotic-welding-text138">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Цифровой сварочный источник</span>
              <br></br>
              <span className="robotic-welding-text141">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система подачи сварочной проволоки</span>
              <br></br>
              <span className="robotic-welding-text144">•</span>
              <span className="robotic-welding-text145">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система очистки и обслуживания горелки</span>
              <br></br>
              <span className="robotic-welding-text148">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Контроллер управления роботизированным комплексом</span>
              <br></br>
              <span className="robotic-welding-text152">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Программное обеспечение Arcobo</span>
              <br></br>
              <span className="robotic-welding-text156">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Защитные ограждения с датчиками безпасности</span>
              <br></br>
              <span className="robotic-welding-text160">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>
                Рабочий стол или позиционер (в зависимости от проекта)
              </span>
            </span>
          </Fragment>
        }
        text2={
          <Fragment>
            <span className="robotic-welding-text163">
              <span>
                Сварочные процессы:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text165">
                MIG/MAG, TIG, CMT, Laser Hybrid*
              </span>
              <br></br>
              <span>Количество осей:</span>
              <span className="robotic-welding-text168">до 16</span>
              <br></br>
              <span>
                Работа 24/7:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text171">да</span>
              <br></br>
              <span>
                Система поиска детали:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text174">
                Touch Sensing / Лазерный сканер
              </span>
              <br></br>
              <span>
                Контроль качества процесса:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text177">Онлайн-мониторинг</span>
              <br></br>
              <span>
                Производительность:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text180">
                до ×5 выше ручной сварки
              </span>
              <br></br>
              <span>
                Интеграция с MES/ERP:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text183">опция</span>
              <br></br>
              <span>
                Удаленная диагностика:
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="robotic-welding-text186">да</span>
              <br></br>
            </span>
          </Fragment>
        }
        text3={
          <Fragment>
            <span className="robotic-welding-text188">
              <span className="robotic-welding-text189">•</span>
              <span className="robotic-welding-text190">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Одно- и двухосевые позиционеры</span>
              <br className="robotic-welding-text192"></br>
              <span className="robotic-welding-text193">•</span>
              <span className="robotic-welding-text194">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Линейная ось робота</span>
              <br className="robotic-welding-text196"></br>
              <span className="robotic-welding-text197">•</span>
              <span className="robotic-welding-text198">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Лазерное слежение за швом</span>
              <br className="robotic-welding-text200"></br>
              <span className="robotic-welding-text201">•</span>
              <span className="robotic-welding-text202">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Touch Sensing</span>
              <br className="robotic-welding-text204"></br>
              <span className="robotic-welding-text205">•</span>
              <span className="robotic-welding-text206">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Машинное зрение</span>
              <br className="robotic-welding-text208"></br>
              <span className="robotic-welding-text209">•</span>
              <span className="robotic-welding-text210">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Система удаления сварочного дыма</span>
              <br className="robotic-welding-text212"></br>
              <span className="robotic-welding-text213">•</span>
              <span className="robotic-welding-text214">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Автоматическая смена инструмента</span>
              <br className="robotic-welding-text216"></br>
              <span className="robotic-welding-text217">•</span>
              <span className="robotic-welding-text218">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Kolarc Cloud и удаленный мониторинг оборудования</span>
            </span>
          </Fragment>
        }
        text4={
          <Fragment>
            <span className="robotic-welding-text220">
              <span>• Одно- и двухосевые позиционеры</span>
              <br></br>
              <span>• Линейная ось робота</span>
              <br></br>
              <span>• Лазерное слежение за швом</span>
              <br></br>
              <span>• Touch Sensing</span>
              <br></br>
              <span>• Машинное зрение</span>
              <br></br>
              <span>• Система удаления сварочного дыма</span>
              <br></br>
              <span>• Автоматическая смена инструмента</span>
              <br></br>
              <span>• Kolarc Cloud и удаленный мониторинг оборудования</span>
              <br></br>
            </span>
          </Fragment>
        }
        text5={
          <Fragment>
            <span className="robotic-welding-text237">
              <span className="robotic-welding-text238">•</span>
              <span className="robotic-welding-text239">
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Машиностроения</span>
              <br></br>
              <span className="robotic-welding-text242">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Производства металлоконструкций</span>
              <br></br>
              <span className="robotic-welding-text245">
                •
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Железнодорожной отрасли</span>
              <br></br>
              <span className="robotic-welding-text248">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Нефтегазового оборудования</span>
              <br></br>
              <span className="robotic-welding-text252">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Энергетического машиностроения</span>
              <br></br>
              <span className="robotic-welding-text256">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Горнодобывающей промышленности</span>
              <br></br>
              <span className="robotic-welding-text260">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Производства сельхозтехники</span>
              <br></br>
              <span className="robotic-welding-text264">•</span>
              <span>
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span>Автомобильной промышленности</span>
            </span>
          </Fragment>
        }
        heading1="A. Базовая комплектация:"
        heading2="B. Базовые характеристики:"
        heading3="C. Дополнительные опции:"
        heading5="D. Подходит для:"
        showDiv1
        showDiv4={false}
        showDiv5
        mainHeading="Характеристики базовой ячейки "
        rootClassName="componentparametersroot-class-name1"
      ></Componentparameters>
      <Component3images
        image1Src="/1_Solution/1_1_1_Welding/204_welding-200h.webp"
        image1Alt="Сварочная роботизированная ячейка"
        image2Src="/1_Solution/1_1_1_Welding/205_welding-200h.webp"
        image2Alt="Сварочная роботизированная ячейка"
        image3Src="/1_Solution/1_1_1_Welding/206_welding-200h.webp"
        image3Alt="Сварочная роботизированная ячейка"
        rootClassName="component3imagesroot-class-name3"
      ></Component3images>
      <hr className="robotic-welding-separator4"></hr>
      <Componentfaq
        answer1={
          <Fragment>
            <span className="robotic-welding-text267">
              <span>
                Комплексы Arcobo применяются для сварки металлоконструкций,
                корпусов оборудования, рам, резервуаров, трубных узлов,
                сельскохозяйственной техники, деталей железнодорожного
                транспорта, трансформаторов и других изделий из стали,
                нержавеющей стали и алюминиевых сплавов.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer2={
          <Fragment>
            <span className="robotic-welding-text270">
              Максимальный эффект достигается при серийном и среднесерийном
              производстве, высокой повторяемости изделий, дефиците
              квалифицированных сварщиков и необходимости обеспечить стабильное
              качество продукции.
            </span>
          </Fragment>
        }
        answer3={
          <Fragment>
            <span className="robotic-welding-text271">
              <span>
                Срок окупаемости зависит от объема производства, номенклатуры
                изделий и режима работы предприятия. Для большинства серийных
                производств инвестиции окупаются за счет роста
                производительности, сокращения брака и снижения затрат на ручной
                труд.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer4={
          <Fragment>
            <span className="robotic-welding-text274">
              <span>
                Комплексы Arcobo поддерживают сварку углеродистых и нержавеющих
                сталей, алюминиевых сплавов, высокопрочных сталей и других
                материалов. Подбор технологии выполняется инженерами Arcobo под
                требования конкретного изделия.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer5={
          <Fragment>
            <span className="robotic-welding-text277">
              <span>
                Комплексы Arcobo поддерживают сварку углеродистых и нержавеющих
                сталей, алюминиевых сплавов, высокопрочных сталей и других
                материалов. Подбор технологии выполняется инженерами Arcobo под
                требования конкретного изделия.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer6={
          <Fragment>
            <span className="robotic-welding-text280">
              <span className="robotic-welding-text281">✓</span>
              <span>
                {' '}
                Официальный партнер Kawasaki Robotics в Казахстане и Центральной
                Азии.
              </span>
              <br></br>
              <span className="robotic-welding-text284">✓</span>
              <span>
                {' '}
                Полный цикл реализации проекта — от аудита производства до
                запуска комплекса и сервисной поддержки.
              </span>
              <br></br>
              <span className="robotic-welding-text287">✓</span>
              <span>
                {' '}
                Собственное производство оснастки и роботизированных ячеек в
                Алматы.
              </span>
              <br></br>
              <span className="robotic-welding-text290">✓</span>
              <span>
                {' '}
                Интеграция оборудования ведущих мировых производителей (Kawasaki
                Robotics, Kolarc и других).
              </span>
              <br></br>
              <span className="robotic-welding-text293">✓</span>
              <span>
                {' '}
                Разработка технологии сварки под конкретное изделие, а не
                поставка типового оборудования.
              </span>
              <br></br>
            </span>
          </Fragment>
        }
        answer7={
          <Fragment>
            <span className="robotic-welding-text296">answer</span>
          </Fragment>
        }
        answer8={
          <Fragment>
            <span className="robotic-welding-text297">answer</span>
          </Fragment>
        }
        showDiv1={false}
        showDiv2={false}
        showDiv3={false}
        showDiv4={false}
        showDiv5={false}
        showDiv6
        showDiv7
        question1="Какие изделия можно сваривать роботизированным способом?"
        question2="Когда роботизированная сварка наиболее эффективна?"
        question3="Можно ли автоматизировать существующий сварочный участок?"
        question4="Как быстро окупается роботизированная сварка?"
        question5="Какие материалы поддерживаются?"
        question6="Почему выбирают Arcobo?"
        question7="question"
        rootClassName="componentfaqroot-class-name1"
      ></Componentfaq>
      <hr className="robotic-welding-separator5"></hr>
      <FooterMain rootClassName="footer-mainroot-class-name13"></FooterMain>
    </div>
  )
}

export default RoboticWelding
